import { styled } from '@mui/system';
import Typography from '@mui/material/Typography';

export const CarTitle = styled(Typography)(() => ({
  fontSize: '1.2rem',
}));
export default CarTitle;
